<ng-container *ngIf="viewData as data">
  <article class="container">
    <ifc-id-verse-mobile-app-banner
      *ngIf="data.state.currentFlowType === IdVerseFlowType.MobileAppPromo"
      [qrCodeUrl]="data.mobileDownloadUrl"
      [appStoreUrl]="data.appStoreUrl"
      [playStoreUrl]="data.playStoreUrl"
      [headerLogoUrl]="data.logoUrl"
      [qrLogoUrl]="data.qrLogoUrl"
      [deviceData]="data.deviceData"
      (continueInBrowser)="onClickContinueInBrowser()"
    >
    </ifc-id-verse-mobile-app-banner>

    <ifc-id-verse-standard-flow-section
      *ngIf="data.state.currentFlowType === IdVerseFlowType.StandardPendingFlow"
      [verificationUrl]="data.state.verificationUrl"
      [deviceData]="data.deviceData"
      [headerLogoUrl]="data.logoUrl"
      [qrLogoUrl]="data.qrLogoUrl"
      (continue)="onClickPendingContinue()"
    >
    </ifc-id-verse-standard-flow-section>

    <ifc-id-verse-mobile-syncing-section
      *ngIf="data.state.currentFlowType === IdVerseFlowType.MobileSyncing"
    >
    </ifc-id-verse-mobile-syncing-section>

    <ifc-id-verse-status-message
      *ngIf="data.state.currentFlowType === IdVerseFlowType.Success"
      [type]="IdVerseStatusType.Success"
      [advisorData]="advisorData"
      (action)="onClickSuccessContinue()"
    >
    </ifc-id-verse-status-message>

    <ng-container *ngIf="data.state.currentFlowType === IdVerseFlowType.Failed">
      <ifc-id-verse-status-message
        *ngIf="data.state.failedAction === IdVerseFailedAction.TryAgainOnError || data.state.failedAction === IdVerseFailedAction.TryAgainOnExpired"
        [type]="data.state.failedAction === IdVerseFailedAction.TryAgainOnExpired ? IdVerseStatusType.FailedExpired : IdVerseStatusType.FailedRetry"
        [advisorData]="advisorData"
        (action)="onClickTryAgain()"
      >
      </ifc-id-verse-status-message>

      <ifc-id-verse-status-message
        *ngIf="data.state.failedAction === IdVerseFailedAction.SwitchToKba"
        [type]="IdVerseStatusType.SwitchToKba"
        [advisorData]="advisorData"
        [customerName]="data.customerName"
        (action)="onClickSwitchToKba()"
      >
      </ifc-id-verse-status-message>
    </ng-container>
  </article>
</ng-container>
